// extracted by mini-css-extract-plugin
export var addressFields = "_o1-0";
export var animationContainer = "_o1-1";
export var footer = "_o1-2";
export var lineItems = "_o1-3";
export var modalContent = "_o1-4";
export var orderName = "_o1-5";
export var strong = "_o1-6";
export var warning = "_o1-7";